import React, { useState, useEffect } from "react";
import { Table, Image, Accordion, Row, Form, Col } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import BasicPagination from "../../Pagination/Pagination";
import Filter from "../offers/Filter";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter, NavLink, Redirect } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { get_events_details } from "../../../store/actions/vendorOffersAndEventsAction";
import isEmpty from "../../../store/validation/is-Empty";
import { EventManagementTableBody } from "./EventManagementTableBody";
import Media from "react-media";
import { EventMobile } from "./EventMobile";
import BottomNavigationMobile from "../navigationSection/BottomNavigationMobile";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import NoContent from "../../reusableComponents/NoContentComponent";

const Event = (props) => {
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [OfferType, SetOfferType] = useState(0);
  const [OfferStatus, SetOfferStatus] = useState(0);
  const [state, setState] = useState({
    open: false,
    ratingChecked: true,
    serviceChecked: false,
    search: "",
    tempCount: 0,
    ratingCount: 0,
  });

  const openModal = (e) => {
    setState({
      ...state,
      open: true,
    });
  };

  const fillerClick = (type) => (e) => {
    setState({
      ...state,
      tempCount: type,
    });
    SetOfferType(type);
  };

  const handleResetClick = () => (e) => {
    setState({
      ...state,
      ratingCount: 0,
      tempCount: 0,
    });
    SetOfferType(0);
  };

  const handleCloseModal = (e) => {
    setState({
      ...state,
      ratingCount: state.tempCount,
      open: false,
    });
  };

  const handleCheckedRating = (e) => {
    setState({
      ...state,
      ratingChecked: !state.ratingChecked,
      serviceChecked: !state.serviceChecked,
    });
  };

  const onSearchChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
    const token = props.auth.user.accessToken;
    props.get_events_details(token);
  }, [get_events_details]);
  const [scanData, setScanData] = useState({});
  const renderTableData = () => {
    const getAllEvents = !isEmpty(props.vendorAllEvents)
      ? props.vendorAllEvents
      : [];
    let filtereddata = [];
    if (state.ratingCount === 0 && OfferType === 0) {
      filtereddata = getAllEvents;
    }
    if (state.ratingCount === 1) {
      filtereddata = getAllEvents.filter(
        (data) => data && data.active === true
      );
    } else if (state.ratingCount === 2) {
      filtereddata = getAllEvents.filter(
        (data) => data && data.active === false
      );
    }
    if (OfferType === 1) {
      filtereddata = getAllEvents.filter(
        (data) => data && data.isOnline === true
      );
    } else if (OfferType === 2) {
      filtereddata = getAllEvents.filter(
        (data) => data && data.isOnline === false
      );
    }
    if (state.search) {
      let search = new RegExp(state.search, "i");
      filtereddata = getAllEvents.filter((getall) => {
        if (search.test(getall?.name)) {
          return getall;
        } else if (search.test(getall?.coupon_code)) {
          return getall;
        } else if (search.test(getall?.event_id)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata
        .slice(start, end)
        .map((data, index) => (
          <React.Fragment key={index}>
            {props?.location?.state?.event_id?.toString() ===
            data.event_id?.toString() ? (
              onSuccesScan(data)
            ) : (
              <EventManagementTableBody data={data} />
            )}
          </React.Fragment>
        ));
    } else {
      return <NoContent/>;
    }
  };
  const onSuccesScan = (eventData) => {
    if (!eventData.isOnline) {
      if (props?.location?.state?.event_type === "TICKET_BOOKED") {
        history.push({
          pathname: `/offline-events-booked/${eventData._id}`,
          state: {
            ...props?.location?.state,
            offlineEventInformation: eventData._id,
          },
        });
      } else {
        history.push({
          pathname: `/offline-events-details/${eventData._id}`,
          state: {
            ...props?.location?.state,
            offlineEventInformation: eventData._id,
          },
        });
      }
    }
  };
  /****************************************
   * @DESC Offer Mobile View Components
   ***************************************/
  const renderOfferAccordian = () => {
    const getAllEvents = !isEmpty(props.vendorAllEvents)
      ? props.vendorAllEvents
      : [];
    let filtereddata = [];
    if (state.ratingCount === 0 && OfferType === 0) {
      filtereddata = getAllEvents;
    }
    if (state.ratingCount === 1) {
      filtereddata = getAllEvents.filter(
        (data) => data && data.active === true
      );
    } else if (state.ratingCount === 2) {
      filtereddata = getAllEvents.filter(
        (data) => data && data.active === false
      );
    }
    if (OfferType === 1) {
      filtereddata = getAllEvents.filter(
        (data) => data && data.isOnline === true
      );
    } else if (OfferType === 2) {
      filtereddata = getAllEvents.filter(
        (data) => data && data.isOnline === false
      );
    }
    if (state.search) {
      let search = new RegExp(state.search, "i");
      filtereddata = getAllEvents.filter((getall) => {
        if (search.test(getall.name)) {
          return getall;
        } else if (search.test(getall.coupon_code)) {
          return getall;
        } else if (search.test(getall?.event_id)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    if (!isEmpty(filtereddata)) {
      return filtereddata.slice(start, end).map((data, index) => (
        <React.Fragment key={index}>
          <EventMobile data={data} indexKey={index} />
        </React.Fragment>
      ));
    } else {
      return <NoContent/>;
    }
  };

  // useEffect(() => {
  //   if (this?.props?.location?.state?.event_id) {
  //     setScanData(this?.props?.location?.state);
  //   }
  // }, [this?.props?.location?.state?.event_id]);
  if (props.auth.loader) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    if (
      props.subscriptionData?.casual_dining_status?.event_management?.value ===
      false
    ) {
      return <Redirect to="/customerbusiness"></Redirect>;
    }
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
            </Media>
            <div className="mobile-right-side-panel super-admin-right-side-panel pb-4">
              <div className="super-admin-inside-right-side-panel margin-bottom-150px">
                <RightSideNavigation displayButton="addEvent" />
                <Media query="(min-width: 992px)">
                  <div className="d-flex justify-content-between align-items-center pt-4 pb-4">
                    <div className="f24_700_HelveticaNeue">
                      Event Management
                    </div>
                    {props.subscriptionData?.casual_dining_status
                      ?.event_management?.value === false ? (
                      ""
                    ) : (
                      <NavLink
                        to="/event/add-event"
                        className="btn btn-danger btn2 btn-lg"
                      >
                        + Add Event
                      </NavLink>
                    )}
                  </div>
                </Media>
                <Media query="(max-width: 991px)">
                  <>
                    <div className="d-flex align-items-start">
                      <NavLink
                        to="/offer"
                        variant="link"
                        className={`btn btn-link`}
                      >
                        <Image
                          src={require("../../../assets/images/Menu/vandorGridMenu/1.svg")}
                          alt="offer"
                          title="offer"
                          width="40px"
                          height="40px"
                        />
                        <span className="f12-400 text-center d-block w-100 mt-2">
                          Offers
                        </span>
                      </NavLink>
                      <NavLink
                        to="/event"
                        variant="link"
                        className={`btn btn-link`}
                      >
                        <Image
                          src={require("../../../assets/images/Menu/vandorGridMenu/2-red.svg")}
                          alt="event"
                          title="event"
                          width="40px"
                          height="40px"
                        />
                        <span className="text-red f12-400  text-center d-block w-100 mt-2">
                          Events
                        </span>
                      </NavLink>
                    </div>
                    <hr />
                  </>
                </Media>
                <Row className="align-items-center">
                  <Col className="col-auto  mobile-order-2">
                    <Filter
                      displayBy="Event"
                      onHendleClick={fillerClick}
                      handleCloseModal={handleCloseModal}
                      open={state.open}
                      onOpenModal={openModal}
                      handleReset={handleResetClick}
                      ratingChecked={state.ratingChecked}
                      serviceChecked={state.serviceChecked}
                      ratingCheckedClick={handleCheckedRating}
                      orderTypeData={(data) => SetOfferType(data)}
                      paymentTypeData={(data) =>
                        setState({ ...state, ratingCount: data })
                      }
                    />
                  </Col>
                  <Col md={4} xs={8}>
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      className="amSearch"
                      name="search"
                      onChange={onSearchChange}
                      value={state.search}
                    />
                  </Col>
                </Row>
                <Media query="(min-width: 992px)">
                  <div className="user-table-reusable-superadmin table-responsive">
                    <Table>
                      <thead>
                        <tr className="super_admin_all_users_table_head">
                          <th style={{ width: "25%" }} className="f12-700">
                            Event
                          </th>
                          <th style={{ width: "15%" }} className="f12-700">
                            Start Date
                            <br />
                            End date
                          </th>
                          <th style={{ width: "15%" }} className="f12-700">
                            Timing
                          </th>
                          <th style={{ width: "12%" }} className="f12-700">
                            Status
                          </th>
                          <th style={{ width: "13%" }} className="f12-700">
                            Primary
                          </th>
                          <th style={{ width: "20%" }} className="f12-700">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      {renderTableData()}
                    </Table>
                  </div>
                </Media>
                <Media query="(max-width: 991px)">
                  <>
                    <div className="row align-items-center seating-dashboard-table">
                      <div className="col-7 mpr-1">
                        <p className="f12-700 pl-3">Events</p>
                      </div>
                      <div className="col-3 px-0">
                        <p className="f12-700">
                          Start Date &<br />
                          <span className="text-red">End Date</span>
                        </p>
                      </div>
                      <div className="col-2 mpl-1">
                        <p className="f12-700">Status</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 p-0">
                        <Accordion>{renderOfferAccordian()}</Accordion>
                      </div>
                    </div>
                  </>
                </Media>
                <BasicPagination
                  totalRecords={
                    props.vendorAllEvents && props.vendorAllEvents.length
                  }
                  limit={10}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

Event.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  vendorAllEvents: state.offersevents.vendor_all_events,
  subscriptionData: state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_events_details,
})(withRouter(Event));
